/**
 * LearnsHero — the centered, no-card intro at the top of `/learns`.
 *
 * Eyebrow + 52px serif headline with the "written for curious kids."
 * phrase highlighted in accent-deep, and a muted subhead. Per the spec
 * this sits directly on the page background — no container card — because
 * the landing page wants to feel airier than the Library's section
 * rhythm.
 *
 * The grade/reading-level selector was removed once the catalogue moved
 * away from grade-banded articles. `useLearningStore` still tracks a
 * reading level for other surfaces (Library, recommendations) that
 * continue to gate by reading level.
 */
export function LearnsHero() {
  return (
    <section className="text-center" style={{ paddingTop: '36px', paddingBottom: '28px' }}>
      {/* --- Eyebrow --- */}
      <div
        className="inline-flex items-center justify-center"
        style={{
          gap: '6px',
          fontFamily: 'Inter, sans-serif',
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: '#1F6A6A',
        }}
      >
        Ollie Learns · BETA
      </div>

      {/* --- Display headline --- */}
      <h1
        style={{
          fontFamily: '"DM Serif Display", serif',
          fontWeight: 400,
          fontSize: '52px',
          lineHeight: 1.05,
          letterSpacing: '-0.02em',
          color: '#1F1B16',
          maxWidth: '720px',
          margin: '12px auto 14px',
        }}
      >
        Real stories and news from around the world
      </h1>

      {/* --- Subhead --- */}
      <p
        style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: 1.5,
          color: '#8A7F72',
          maxWidth: '600px',
          margin: '0 auto 0',
        }}
      >
        History, science, the arts, and what&apos;s happening this week.
      </p>
    </section>
  );
}
